<template>
    <div>
        <default-homepage-settings> </default-homepage-settings>

        <default-dashboard-settings> </default-dashboard-settings>
    </div>
</template>

<script>
    export default {
        name:'default-settings',
    }
</script>
